import { render, staticRenderFns } from "./management_fees.vue?vue&type=template&id=cb8b41d0&"
import script from "./management_fees.vue?vue&type=script&lang=js&"
export * from "./management_fees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports